import { forwardRef, Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { HeaderPickerComponent, SupportHeaderPanel } from './header-picker.component';

@Component({
  selector: 'nz-month-picker',
  template: `<nz-picker [isRange]="false" [value]="nzValue" (valueChange)="onValueChange($event)" [open]="nzOpen" [disabled]="nzDisabled" [format]="nzFormat" [allowClear]="nzAllowClear" [autoFocus]="nzAutoFocus" [className]="nzClassName" [placeholder]="nzPlaceHolder" [size]="nzSize" [style]="nzStyle" (openChange)="onOpenChange($event)" > <div *ngIf="realOpenState"> <div class="ant-calendar-picker-container {{ nzDropdownClassName }} ant-calendar-picker-container-placement-bottomLeft" [ngStyle]="nzPopupStyle"> <div class="ant-calendar ant-calendar-month ant-calendar-month-calendar" tabindex="0"> <div class="ant-calendar-month-calendar-content"> <div class="ant-calendar-month-header-wrap"> <calendar-header [disabledMonth]="nzDisabledDate" [panelMode]="panelMode" (panelModeChange)="onPanelModeChange($event)" [value]="nzValue" (chooseYear)="onChooseValue('year', $event)" (chooseMonth)="onChooseValue('month', $event)" [locale]="nzLocale.lang" [enablePrev]="true" [enableNext]="true" ></calendar-header> </div> <calendar-footer *ngIf="extraFooter" [extraFooter]="extraFooter"></calendar-footer> </div> </div> </div> </div> </nz-picker>`,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    multi: true,
    useExisting: forwardRef(() => NzMonthPickerComponent)
  }],
  host               : {
    '[class.ant-checkbox-group]': 'true'
  }
})

export class NzMonthPickerComponent extends HeaderPickerComponent {
  @Input() nzFormat: string = 'yyyy-MM';

  endPanelMode: SupportHeaderPanel = 'month';
}
